// ** Type import
import { HorizontalNavItemsType } from 'src/@core/layouts/types'

const navigation = (): HorizontalNavItemsType => [
    {
        title: 'Home',
        path: '/home',
        icon: 'mdi:home-outline'
    },
    {
        title: 'Dashboard',
        path: '/dashboard',
        icon: 'mdi:chart-line'
    },
    {
        title: 'Notificaciones',
        path: '/notifications',
        icon: 'mdi:bell-outline'
    },
    {
        title: 'Limites',
        path: '/limits',
        icon: 'mdi:chart-box-outline'
    },
    {
        title: 'Administración',
        path: '/admin',
        icon: 'mdi:account-group-outline',
        securityObject: 'MenuAccesoModuloAdministrador'
    },
    {
        title: 'Visualizador',
        path: '/grafo',
        icon: 'mdi:eye-outline',
        securityObject: 'RutaWorkflowGrafo'
    }
]

export default navigation
